module.exports = "<div class=\"knob\">\n    <div class=\"knob-inside\">\n    </div>\n</div>";
